"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterConfig = require("react-router-config");
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var redirect = false;
var Authorization = /*#__PURE__*/function (_React$Component) {
  _inherits(Authorization, _React$Component);
  var _super = _createSuper(Authorization);
  function Authorization(props) {
    var _this;
    _classCallCheck(this, Authorization);
    _this = _super.call(this, props);
    _this.checkAuth(props.location);
    return _this;
  }
  _createClass(Authorization, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      /**
       * If route is changed
       * Update auths
       */
      if (!_lodash.default.isEqual(this.props.location.pathname, prevProps.location.pathname)) {
        this.checkAuth(this.props.location);
      }
    }
  }, {
    key: "checkAuth",
    value: function checkAuth(originalLocation) {
      var token = localStorage.getItem('authentication_token');

      // if token exsists user is logged in
      if (token) {
        this.props.userAuthonticated();
      }

      // Get matched routes
      var matched = (0, _reactRouterConfig.matchRoutes)(this.props.routes, this.props.location.pathname)[0];
      // Get user roles
      var roles = this.props.user.roles;
      if (matched && matched.route.auth && matched.route.auth.length > 0) {
        if (!roles.some(function (role) {
          return matched.route.auth.includes(role);
        })) {
          // If user don't have the route role redirect him
          redirect = true;
          if (roles.includes('guest')) {
            // If user roles is guest redirect him to login
            this.props.history.push({
              pathname: '/login',
              state: {
                redirectUrl: originalLocation.pathname + (originalLocation.search || '')
              }
            });
          } else {
            if (matched.route.auth.includes('guest')) {
              // If the user was in login or register redirect him to REDIRECT_AFTER_LOGIN_URL path
              this.props.history.push({
                pathname: _config.REDIRECT_AFTER_LOGIN_URL
              });
            } else {
              // Redirect user to previous path if it exists or to REDIRECT_AFTER_LOGIN_URL path
              this.props.history.push({
                pathname: originalLocation ? originalLocation.pathname : _config.REDIRECT_AFTER_LOGIN_URL,
                search: this.props.location.search
              });
            }
          }
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (redirect) {
        redirect = false;
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
    }
  }]);
  return Authorization;
}(_react.default.Component);
function mapDispatchToProps(dispatch) {
  return {
    userAuthonticated: function userAuthonticated() {
      dispatch({
        type: 'USER_ALREAY_AUTHENTICATED'
      });
    }
  };
}
function mapStateToProps(_ref) {
  var auth = _ref.auth;
  return {
    user: auth.user
  };
}
var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Authorization));
exports.default = _default;